import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: LogState = {
  all: [],
};

const getters: GetterTree<LogState, RootState> = {
  all(state: LogState): Log[] {
    return state.all;
  },
};

const mutations: MutationTree<LogState> = {
  RESET(state: LogState) {
    state.all = [];
  },
  SET_MODELS(state: LogState, payload: Log[]) {
    state.all = payload;
  },
};

const resource: string = 'logs';

const actions: ActionTree<LogState, RootState> = {
  index({ commit, rootState }, payload: { id: number; query?: IndexQuery<Log>; workspaceId: number }) {
    return rootState.api
      .get(`orders/${payload.id}/${resource}`, { withCredentials: true, params: payload.query, headers: { common: { 'x-workspace-id': payload.workspaceId } } })
      .then((response: { data: Log }) => {
        commit('SET_MODELS', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
